export default __webpack_public_path__ + "static/media/Footpad's Gloves of the Deceiver.280c9b8c.jpg";